import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Tabs,
  Tab,
  Divider,
  TextField,
  List,
  ListItem,
  ListItemText,
  Button,
  Grid2
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useSelector } from "react-redux";

const styles = (theme) => ({
  height: "80vh",
  "& .videoBox": {
    width: "100%",
    // height: "80%",
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px"
  }
})

const messages = [
  { user: "Vijay", message: "HI" },
  { user: "Karthik Vijayasarathi", message: "hiiiiiiiiiiiiii" },
  { user: "Aravintha Prasath", message: "Helloo" },
  { user: "Daksh Rai", message: "good evening" },
  { user: "M Dhayalan", message: "Hi" },
  { user: "Asma Shaik", message: "What's special Mohit" },
  { user: "Daksh Rai", message: "yes" },
];

const LectureDialog = ({ open, onClose, session }) => {
    console.log('session: ', session);
    const [tab, setTab] = React.useState(0);

    const { Profile, Translation } = useSelector((state) => ({
      Profile: state.Profile.profile,
      Translation: state.Translation.translation?.Course || {},
    }));

    return (
        <Dialog open={open} onClose={() => onClose(false)} maxWidth="lg" fullWidth>
        <DialogContent sx={{ display: "flex", p: 0 }}>
            {/* Left - Video Section */}
            {/* <Grid2 sx={styles}> */}
                <Box flex={2} position="relative" sx={styles}>
                <Box position="absolute" top={0} left={0} right={0} sx={{ zIndex: 2 }}>
                    <Typography variant="subtitle1">{`${Translation?.Day} ${session?.Day}`}</Typography>
                    {/* <Box mt={1} sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}> */}

                        <video className="videoBox" controls autoPlay>
                            <source src={session?.RecordingURL} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>

                    {/* {["Quiz 1 (32:21)", "Quiz 2 (1:12:27)", "Quiz 3 (1:51:12)", "Quiz 4 (1:52:06)", "Quiz 5 (1:56:55)", "Quiz 6 (2:03:57)"].map((quiz, index) => (
                        <Button key={index} variant="contained" size="small">
                        {quiz}
                        </Button>
                    ))} */}
                    </Box>
                </Box>

                {/* <Box height="100%" display="flex" justifyContent="center" alignItems="center" sx={{ bgcolor: "#111" }}>
                    <PlayArrowIcon sx={{ fontSize: 80, color: "#fff" }} />
                </Box> */}
                {/* </Box> */}

                {/* Right - Chat Section */}
                {/* <Box flex={1} borderLeft="1px solid #ccc" height="100%" display="flex" flexDirection="column">
                

                <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)} centered>
                    <Tab label="Notice Board" />
                    <Tab label="Chat" />
                </Tabs>
                <Divider />

                <Box flex={1} overflow="auto" px={2} py={1}>
                    <List dense>
                    {messages.map((msg, index) => (
                        <ListItem key={index} alignItems="flex-start">
                        <ListItemText
                            primary={
                            <Typography variant="body2" fontWeight="bold" color="primary">
                                {msg.user}
                            </Typography>
                            }
                            secondary={<Typography variant="body2">{msg.message}</Typography>}
                        />
                        </ListItem>
                    ))}
                    </List>
                </Box>

                <Divider />
                <Box p={1}>
                    <TextField fullWidth size="small" placeholder="Type a message..." />
                </Box>
                </Box> */}
            {/* </Grid2> */}
        </DialogContent>
        </Dialog>
    );
};

export default LectureDialog;
